import Axios from "@/plugins/Axios";

export class RelatoriosService {
  async carteira(matricula) {
    const response = await Axios()
      .get(`cartao/${matricula}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `carteira_${matricula}.pdf`;
        link.click();
      });
    return response;
  }

  async listarTurma(turma) {
    const response = await Axios()
      .get(`relatorios/listarTurma/${turma}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `listar_turma_${turma}.pdf`;
        link.click();
      });
    return response;
  }

  async boletimGeral(turma) {
    const response = await Axios()
      .get(`relatorios/boletimGeral/${turma}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = `boletim_turma_${turma}.pdf`;
        // link.click();
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async mapaDeMatriculasPorEscola(franquia_id) {
    const response = await Axios()
      .get(`relatorios/mapa_matriculas_escola/${franquia_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "mapa_matriculas_escola.pdf";
        link.click();
      });
    return response;
  }

  async relatorioBNCC(matricula_id) {
    const response = await Axios()
      .get(`relatorios/relatorioBNCC/${matricula_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = `ralatorio_bncc_matricula_${matricula_id}.pdf`;
        // link.click();
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioSemestralBNCC(matricula_id) {
    const response = await Axios()
      .get(`relatorios/relatorioSemestralBNCC/${matricula_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async boletimIndividual(matricula_id) {
    const response = await Axios()
      .get(`relatorios/turmaBoletimIndividual/${matricula_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = `boletim_individual_matricula_id_${matricula_id}.pdf`;
        // link.click();
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioAee(matricula_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-aee/${matricula_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_do_atendimento_educacional_especial_matricula_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async alunosPorUnidadeEScolar(franquia_id) {
    const response = await Axios()
      .get(`relatorios/alunos_por_unidade/${franquia_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "alunos_por_unidade.pdf";
        link.click();
      });
    return response;
  }

  async alunosPCDPorUnidadeEScolar(franquia_id) {
    const response = await Axios()
      .get(`relatorios/alunos_pcd_por_unidade/${franquia_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "alunos_pcd_por_unidade.pdf";
        link.click();
      });
    return response;
  }

  async boletinsFranquia(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/boletins-franquia/${franquia_id}`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `boletins_franquia_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  // async relatoriosBnccFranquia(franquia_id) {
  //   const response = await Axios()
  //     .get(`relatorios/relatorios-bncc-franquia/${franquia_id}`, {
  //       responseType: "arraybuffer",
  //     })
  //     .then((response) => {
  //       const blob = new Blob([response.data], { type: "application/pdf" });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `relatorios_bncc_franquia_${franquia_id}.pdf`;
  //       link.click();
  //     });
  //   return response;
  // }

  async relatoriosSemestralBnccFranquia(franquia_id) {
    const response = await Axios()
      .get(`relatorios/relatorios-semestral-bncc-franquia/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorios_bncc_franquia_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async escolasTurmasAlunos() {
    const response = await Axios()
      .get("relatorios/escolas_turmas_alunos", { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "escola_relatorio_completo.pdf";
        link.click();
      });
    return response;
  }

  async listarTodasTurmas() {
    const response = await Axios()
      .get("relatorios/listar-todas-turmas", { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "todas_as_turmas_de_todas_escolas.pdf";
        link.click();
      });
    return response;
  }

  async listarTurmasFranquia(franquia_id) {
    const response = await Axios()
      .get(`relatorios/listar-turmas-franquia/${franquia_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "todas_as_turmas_de_uma_escola.pdf";
        link.click();
      });
    return response;
  }

  async inscritosCongresso() {
    const response = await Axios()
      .get("relatorios/inscritos-congresso", { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "inscritos_congresso.pdf";
        link.click();
      });
    return response;
  }

  async diarioFrequencia(gestao_id, mes) {
    const { id } = mes;
    const response = await Axios()
      .get(`relatorios/diario-frequencia/${gestao_id}/${id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `diario_frequencia_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async diarioAulas(gestao_id, mes) {
    const { id } = mes;
    const response = await Axios()
      .get(`relatorios/diario-aulas/${gestao_id}/${id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `diario_aulas_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async diarioNotas(gestao_id) {
    const response = await Axios()
      .get(`relatorios/diario-notas/${gestao_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `diario_notas_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioBNCCTurma(turma_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-bncc/${turma_id}/turma`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `ralatorio_bncc_turma_${turma_id}.pdf`;
        link.click();
        return response;
      });
  }

  async relatorioSemestralBNCCTurma(turma_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-semestral-bncc/${turma_id}/turma`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `ralatorio_bncc_turma_${turma_id}.pdf`;
        link.click();
        return response;
      });
  }

  async insercaoAulas() {
    const response = await Axios()
      .get("relatorios/insercao-aulas", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "insercao_aulas.pdf";
        link.click();
      });
    return response;
  }

  async lotacaoGeral() {
    const response = await Axios()
      .get("relatorios/relatorio-lotacao-geral", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "relatorio_lotacao_geral.pdf";
        link.click();
      });
    return response;
  }

  async lotacao() {
    const response = await Axios()
      .get("relatorios/relatorio-lotacao", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "relatorio_lotacao.pdf";
        link.click();
      });
    return response;
  }

  async lotacaoEscola(franquia_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-lotacao-escola/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_lotacao_escola_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async planoBimestral(gestao_id, etapa_id, disciplina_id) {
    const response = await Axios()
      .get(`relatorios/plano-bimestral/${gestao_id}/${etapa_id}/${disciplina_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_bimestral_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async planoMensal(gestao_id, mes_id, disciplina_id) {
    const response = await Axios()
      .get(`relatorios/plano-mensal/${gestao_id}/${mes_id}/${disciplina_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_mensal_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async resultadoPorDisciplina(turma) {
    const response = await Axios()
      .get(`relatorios/resultado-por-disciplinas/${turma}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `resultado_por_disciplina_${turma}.pdf`;
        link.click();
      });
    return response;
  }

  async capaDiarioClasse(gestao_id) {
    const response = await Axios()
      .get(`relatorios/capa/diario-classes/${gestao_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `capa_de_diario_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async resumoMovimentoEscolar(franquia_id) {
    const response = await Axios()
      .get(`relatorios/resumo-movimento-escolar/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `resumo_movimento_escolar_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async declaracaoConclusao(matricula_id) {
    try {
      const response = await Axios().get(`relatorios/declaracao-conclusao/${matricula_id}`, {
        responseType: "arraybuffer",
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `declaracao_de_conclusao_${matricula_id}.pdf`;
      link.click();
      return response;
    } catch (error) {
      if (error instanceof ArrayBuffer) {
        try {
          const decoded = JSON.parse(new TextDecoder("utf-8").decode(error));
          if (decoded.aluno && decoded.turma) {
            const mediaInsuficienteError = new Error(decoded.message);
            mediaInsuficienteError.mediaInsuficiente = decoded;
            throw mediaInsuficienteError;
          }
        } catch (parseError) {
          if (parseError.mediaInsuficiente) throw parseError;
        }
      }
      throw error;
    }
  }

  async declaracaoCurso(matricula_id) {
    const response = await Axios()
      .get(`relatorios/declaracao-curso/${matricula_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `declaracao_de_curso_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async fichaDeMatricula(matricula_id) {
    const response = await Axios()
      .get(`relatorios/ficha-matricula/${matricula_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `ficha_de_matricula_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async documentoJustificativaFalta(aula_id, matricula_id) {
    const response = await Axios()
      .get(`relatorios/falta/baixar-documento/${aula_id}/${matricula_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `documento_de_justificativa_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async documentoJustificativaFaltaPlanejamento(professor_id, planejamento_id) {
    console.log(professor_id, planejamento_id, "service");
    const response = await Axios()
      .get(`relatorios/falta/baixar-documento-planejamento/${professor_id}/${planejamento_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `documento_de_justificativa_${professor_id}.pdf`;
        link.click();
      });
    return response;
  }

  async frenquenciaIndividual(matricula_id, mes) {
    const response = await Axios()
      .get(`relatorios/frenquencia-individual/${matricula_id}/${mes}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `frequencia_individual_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioAuxiliar(gestao_id, disciplina_id, mes) {
    const response = await Axios()
      .get(`relatorios/relatorio-auxiliar/${gestao_id}/${disciplina_id}/${mes}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_auxiliar_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async planoBimestralInfantil(gestao_id, etapa_id) {
    const response = await Axios()
      .get(`relatorios/plano-bimestral-infantil/${gestao_id}/${etapa_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_bimestral_infantil${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioDeListagemDosPlanosLancados(franquia_id) {
    const response = await Axios()
      .get(`relatorios/historico-lancamentos-planos/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `historico_lancamento_planos_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioDeListagemDosPlanosLancadosGeral() {
    const response = await Axios()
      .get(`relatorios/historico-lancamentos-planos-geral`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `historico_lancamento_planos_geral.pdf`;
        link.click();
      });
    return response;
  }

  async relatoriosEvasao(franquia_id) {
    const response = await Axios()
      .get(`relatorios/evasao/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_evasao_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatoriosEvasaoProfessor(franquia_id, month) {
    const response = await Axios()
      .get(`relatorios/evasao-professor/${franquia_id}/${month}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async alunosNaoMatriculados(franquia_id) {
    const response = await Axios()
      .get(`relatorios/alunos-nao-matriculados/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `alunos_nao_matriculados_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async alunosNaoMatriculadosGeral() {
    const response = await Axios()
      .get(`relatorios/alunos-nao-matriculados-geral`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `alunos_nao_matriculados_geral.pdf`;
        link.click();
      });
    return response;
  }

  async qtdProfessoresPorDisciplina() {
    const response = await Axios()
      .get(`relatorios/professores-por-disciplina`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `qtd_professores_por_disciplina.pdf`;
        link.click();
      });
    return response;
  }

  async relatoriosCensoFranquia(franquias_id) {
    const response = await Axios()
      .get(`relatorios/censo/${franquias_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `censo_${franquias_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioTransferenciasFranquia(franquia_id) {
    const response = await Axios().get(`relatorios/transferencias/franquia/${franquia_id}`, {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `relatorio_transferencias_franquia_${franquia_id}.pdf`;
    link.click();

    return response;
  }

  async relatorioTransferencias(turmasIds) {
    const response = await Axios().get("relatorios/transferencias", {
      params: {
        turmas_ids: turmasIds,
      },
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "relatorio_transferencias_turmas.pdf";
    link.click();

    return response;
  }

  async buscarTurmasPorFranquia(turmasIds) {
    const response = await Axios().get("relatorios/transferencias", {
      params: {
        turmas_ids: turmasIds,
      },
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "relatorio_transferencias_turmas.pdf";
    link.click();

    return response;
  }

  async relatoriosUsoDoSistema(mes, franquia_id) {
    const response = await Axios()
      .get(`relatorios/uso-do-sistema/resumido/${mes}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async DesempenhoProfessorPorFranquia(franquia_id) {
    const response = await Axios()
      .get(`relatorios/franquia/${franquia_id}/usabilidade-professores`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `desempenho_professor_franquia_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async DesempenhoProfessorPorTurma(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/turma/${franquia_id}/usabilidade-professores`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `desempenho_professor_turma_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async DesempenhoAlunoPorFranquia(franquia_id) {
    const response = await Axios()
      .get(`relatorios/franquia/${franquia_id}/usabilidade-alunos`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `desempenho_aluno_franquia_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async DesempenhoAlunoPorTurma(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/turma/${franquia_id}/usabilidade-alunos`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `desempenho_aluno_turma_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async DesempenhoCoordenadorPorFranquia(franquia_id) {
    const response = await Axios()
      .get(`relatorios/franquia/${franquia_id}/usabilidade-coordenadores`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `desempenho_coordenador_franquia_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async DesempenhoCoordenadorPorTurma(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/turma/${franquia_id}/usabilidade-coordenadores`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `desempenho_coordenador_turma_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async RelatorioPlanejamentoAulas(planejamento_aula_id) {
    const response = await Axios().get(
      `relatorios/relatorio-planejamento-aulas/${planejamento_aula_id}`,
      { responseType: "arraybuffer" }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `relatorio_planejamento_aulas.pdf`;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  async relatoriosBnccFranquia(franquia_id, turmasSelecionadas) {
    const response = await Axios().post(
      `relatorios/relatorios-bncc-franquia/${franquia_id}`,
      { turmas: turmasSelecionadas },
      { responseType: "arraybuffer" }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `relatorios_bncc_franquia_${franquia_id}.pdf`;
    link.click();

    return response;
  }

  async alunosMatriculadosXls() {
    const response = await Axios()
      .get("relatorios/alunos-matriculados-xls", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/xls" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "alunos_matriculados.xls";
        link.click();
      });
    return response;
  }

  async notifiqAlunosPorTurma(franquia_id) {
    const response = await Axios()
      .get(`relatorios/notifiq/alunos-matriculados/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `notifiq_alunos_por_turma_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async notifiqAcessosEscola(franquia_id) {
    const response = await Axios()
      .get(`relatorios/notifiq/acessos-escola/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `notifiq_acessos_escola_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async faltantesNotifiq(franquia_id, data) {
    const response = await Axios()
      .get(`relatorios/faltantes-notifiq/${franquia_id}`, {
        params: { data },
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `notifiq_faltantes_${franquia_id}_${data}.pdf`;
        link.click();
      });

    return response;
  }

  async presencasNotifiq(franquia_id, dataInicio, dataFim) {
    const response = await Axios()
      .get(`relatorios/notifiq/presencas/${franquia_id}`, {
        params: {
          data_inicio: dataInicio,
          data_fim: dataFim,
        },
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `notifiq_presencas_${franquia_id}_${dataInicio}_${dataFim}.pdf`;
        link.click();
      });
    return response;
  }

  async presencasNotifiqGeral(dataInicio, dataFim) {
    const response = await Axios()
      .get(`relatorios/notifiq/presencas-geral`, {
        params: {
          data_inicio: dataInicio,
          data_fim: dataFim,
        },
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `notifiq_presencas_todas_escolas_${dataInicio}_${dataFim}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioDiarioAtendimento(matricula_id, gestao_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-diario-atendimento/${matricula_id}/${gestao_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioPlanejamentoMensalCAEE(matricula_id, gestao_id, mes_id) {
    const response = await Axios()
      .get(`relatorios/planejamento-mensal-caee/${matricula_id}/${gestao_id}/${mes_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioPlanoCAEE(matricula_id, gestao_id, bimestre) {
    await Axios()
      .get(`relatorios/plano-caee/${matricula_id}/${gestao_id}/${bimestre}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }
}
export default new RelatoriosService();
